<div class="font-sm text-muted" *ngIf="isStockVisible">
  {{ 'cakeBuilder.stockQuantityNotice' | translate:{ count: stockLeft } }}
</div>

<div class="font-sm text-muted" *ngIf="isDailyLimitVisible">
  {{ 'cakeBuilder.dailyLimitQuantityNotice' | translate:{ dailyLimit: dailyLimit } }}
</div>

<div class="font-sm text-muted" *ngIf="maxQuantityNotice">
  {{ maxQuantityNotice }}
</div>

<ng-container *ngIf="minQuantity > 1">
  <div class="font-sm text-muted" *ngIf="!count">
    {{ 'cakeBuilder.upsellsMinQuantity.note' | translate:{ minQuantity: minQuantity } }}
  </div>

  <div class="font-sm text-muted d-flex align-items-center" *ngIf="count">
    <span class="me-1">{{ 'cakeBuilder.upsellsMinQuantity.mustOrder' | translate: { minQuantity: minQuantity } }}</span>
    <span class="me-1"
          [class.text-danger]="count < minQuantity"
          [class.min-quantity-valid]="count >= minQuantity">
    {{ 'cakeBuilder.upsellsMinQuantity.selected' | translate: { minQuantity: minQuantity, count: count } }}
  </span>

    <i *ngIf="count >= minQuantity"
       class="icon-circle-ok-bold lh-1 min-quantity-valid"></i>
  </div>
</ng-container>
